// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './vuex';
import router from './router';
import { sync } from 'vuex-router-sync';

import 'font-awesome/css/font-awesome.min.css';

import element from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
import zoom from 'vue-image-zoom';
import 'vue-image-zoom/dist/vue-image-zoom.css';

import containerMain from './components/container-main';
import cHeader from './components/contentHeader';

import datetimeFormatter from './gadgets/datetimeFormatter.js';
import dateFormatter from './gadgets/dateFormatter.js';
import monthFormatter from './gadgets/monthFormatter.js';
import today from './gadgets/getToday.js';
import AsyncComputed from 'vue-async-computed';
import ECharts from 'vue-echarts/components/ECharts';
import 'echarts';
import { homeUrl, env } from './utils/config';

Vue.component('chart', ECharts);
Vue.use(element);
Vue.use(zoom);
Vue.use(AsyncComputed);

router.beforeEach((to, from, next) => {
  const path = to.path;
  const isLogin = store.getters.isLogin;

  if (to.name !== 'login' && !isLogin) {
    store.dispatch('CHECK_LOGIN').then(() => {
      checkIFace(path);   // Check iFace List
    }).catch(({ status, message }) => {
      console.error({ status, message });
      if (env === 'development') {
        next({ path: '/login', query: { status, message } });
      } else {
        location.replace(homeUrl);
      }
    });
  } else if (isLogin) {
    checkIFace(path);
  } else {    // to.name == 'login'
    next();
  }

  function checkIFace (path) {
    return store.dispatch('CHECK_IFACE_LIST', path).then(() => {
      next();
    });
  }
});

sync(store, router);

Vue.component('containerMain', containerMain);
Vue.component('cHeader', cHeader);

Vue.prototype.$datetimeFormatter = datetimeFormatter;
Vue.prototype.$dateFormatter = dateFormatter;
Vue.prototype.$monthFormatter = monthFormatter;
Vue.prototype.$today = today;
Vue.prototype.$columnFormatter = (row, column, cellValue) => {
  // console.log(row, column, cellValue);
  let text = '-';
  if (cellValue !== undefined && cellValue !== null && cellValue !== '') {
    text = cellValue;
  }
  return text;
};

/* eslint-disable no-new */
const app = new Vue({
  router,
  store,
  ...App // Object spread copying everything from App.vue
});

app.$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js